import OpTableContentFilter from "./index.vue";
var optablecontentfilter = {
  install: function install(Vue) {
    Vue.component("OpTableContentFilter", OpTableContentFilter);
  }
};
export default optablecontentfilter;